import React, { Component } from 'react';
import AddnewMember from './AddnewMember';
import { dataUser } from '../Helpers/util';
import mixpanel from 'mixpanel-browser';
import SwButton from '../Common/SwButtons/SwButtons';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import { toast } from 'react-toastify';
export const MyContext = React.createContext();

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class MainHeadingAddMember extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
      showAddMember: false,
    };
    this.addMemberRef = React.createRef();
  }



handleClose = (isSuccess = false, successMessage = '') => {
  this.setState({ showAddMember: false });

  if (isSuccess && successMessage) {
    // Show the toast, then reload ONLY after it has been displayed.
    // A premature window.location.reload() tears down the React app and
    // wipes the toast before the user can see it.
    toast.success(successMessage, {
      autoClose: 2500,
      onClose: () => window.location.reload(),
    });
  }
};



  componentDidMount() {
    // Simulate data fetching or use your actual API call
    if (!this.state.userRole || this.state.userRole.length === 0) {
      setTimeout(() => {
        this.setState(
          {
            userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
          },
          () => {
            // Force a re-render once the state has been updated
            this.forceUpdate();
          },
        );
      }, 1000); // Simulate async delay (replace with real API call)
    }

    // Listen for localStorage changes
    window.addEventListener('storage', this.handleStorageChange);
  }

  componentWillUnmount() {
    // Clean up event listener when the component unmounts
    window.removeEventListener('storage', this.handleStorageChange);
  }

  handleStorageChange = () => {
    // Re-fetch the user data from localStorage and update the state
    const userDataLocal = dataUser();
    const updatedUserObj = JSON.parse(userDataLocal);

    if (updatedUserObj && updatedUserObj.role_data) {
      this.setState({
        userRole: updatedUserObj.role_data,
      });
    }
  };

  addMemberMixPanel() {
    mixpanel.track('Member Management Add New', {
      PageName: 'Members',
      UserEmail: UserObj.email,
      UserName: UserObj.fname + ' ' + UserObj.lname,
      UserId: UserObj.rec_id,
      CompanyId: UserObj.company_id,
      CompanyName: UserObj.company_name,
      Type: 'Members',
    });
  }

  redirectManageRoles = () => {
    window.location.href = '/ManageRoles';
  };

  render() {
    const { userRole } = this.state;

    // Check if userRole data is available and render based on that
    const ManageMembers = userRole.find(element => element.service_id == '1');
    const ManageRoles = userRole.find(element => element.service_id == '13');

    return (
      <>
        {ManageMembers?.role_for_write === '1' && (
          <>
            {(ManageRoles?.role_for_read === '1' ||
              ManageRoles?.role_for_write === '1') && (
              <SwButton
                type="button"
                variant="dark"
                size="sm"
                className='ToHideMobile'
                onClick={this.redirectManageRoles}
              >
                Manage Roles
              </SwButton>
            )}

            <SwButton
              type="button"
              variant="primary"
              size="sm"
              className='ms-2'
              icon={<i class="bi bi-plus-circle" />}
              iconPosition="start"
              onClick={() => this.setState({ showAddMember: true })}
            >
              Add Member
            </SwButton>

            <SwOffCanvas
              show={this.state.showAddMember}
              onClose={() => this.setState({ showAddMember: false })}
              title="Add New Member"
              placement="end"
              backdrop="static"
              keyboard={false}
              footer={
                <div className="OffCanvasFooter_Btns">
                  <SwButton
                    variant="dark-outline"
                    // icon={<i class="bi bi-arrow-clockwise"></i>}
                    onClick={() => {
                      this.addMemberRef.current?.reload();
                    }}
                  >
                    Reset
                  </SwButton>

                
                    <SwButton
                      variant="primary"
                      onClick={e =>
                        this.addMemberRef.current?.addmemberSubmitHandler(e)
                      }
                    >
                      Submit
                    </SwButton>
               
                </div>
              }
            >
              <AddnewMember
                ref={this.addMemberRef}
                onClose={this.handleClose}
                onSuccess={this.closeAddMember}
              />
            </SwOffCanvas>
          </>
        )}
      </>
    );
  }
}

export default MainHeadingAddMember;
